import React, { useEffect } from 'react';
import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import { hasEmail, isEmptyObject, showNotificationDialog } from '../../utils';
import { useTranslation } from 'react-i18next';
import { IS_IN_PURCHASE, localStorageKeys } from '../../utils/Constants';
import { useFujiAuth } from '../../auth/useFujiAuth';

/**
 * Splash画面
 */
const Splash = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { user } = useFujiAuth();

    useEffect(() => {
        // ソーシャルログイン時の対応チケット情報がある場合は購入画面に遷移、ない場合は図 1-1画面 に遷移
        const isSocialLogin = localStorage.getItem('isSocialLogin') != null;
        localStorage.removeItem('isSocialLogin');

        if (isSocialLogin) {
            showNotificationDialog(
                'success',
                'login_successfully',
                t('notification.title'),
                t('notification.login-success'),
            );

            // ログインに成功して、画面遷移を行う
            const isInPurchase = localStorage.getItem(IS_IN_PURCHASE) !== null;
            const loginFlow = JSON.parse(localStorage.getItem(localStorageKeys.LOGIN_FLOW) ?? '{}');
            if (isInPurchase || !isEmptyObject(loginFlow)) {
                // 購入中もしくは購入済み一覧からログインした場合は戻る。
                navigate(loginFlow.path, { state: loginFlow.state });
            } else {
                if (user && !hasEmail(user)) {
                    navigate('/profile/info/change-mail');
                } else {
                    navigate('/profile');
                }
            }
            return;
        }

        // 退会処理でエラーが発生した場合
        if (
            localStorage.getItem('deleteUser.error') !== null &&
            localStorage.getItem('deleteUser.error')?.includes('UserNotFoundException')
        ) {
            localStorage.removeItem('deleteUser.error');
            // 既に退会済みのエラーメッセンジを表示
            showNotificationDialog(
                'failed',
                'delete-account',
                t('notification.title'),
                t('error-message.delete-account.no-user'),
            );
            // 購入画面に遷移
            navigate('/buy', { replace: true });
        }
        navigate('/buy', { replace: true });
    }, [user, navigate, t]);

    return (
        <React.Fragment>
            <div className={styles.splash}>
                <img src="/images/splash.svg" alt="" />
            </div>
        </React.Fragment>
    );
};

export default Splash;
